import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceGql } from './DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceGql';

export const FlowUpstreamDatasourcesWithoutPersonalSpaceQueryGql: DocumentNode = gql`
query FlowUpstreamDatasourcesWithoutPersonalSpaceQuery($flowVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  flows(filter: { vizportalUrlId: $flowVizportalUrlId }) {
    upstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
${DatasourcesDisplayGridRowDataFragmentWithoutPersonalSpaceGql}
`;
